import { memo } from 'react'

import { Button, useDialogState } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'
import { getCurrentUserId, getCurrentUserSignature } from '@tabeeb/modules/account/selectors'
import { ContentFormRecordType } from '@tabeeb/contracts/main-api/swagger-main-api'

import ManageSignatureDialog from './ManageSignatureDialog'
import { saveFormRecord } from '../../actions'
import { getCurrentForm } from '../../selectors'

const Signature = () => {
  const dispatch = useDispatch()

  const signature = useSelector(getCurrentUserSignature)
  const form = useSelector(getCurrentForm)
  const currentUserId = useSelector(getCurrentUserId)

  const [isOpen, onOpen, onClose] = useDialogState()

  const handleClick = () => {
    if (signature) {
      dispatch(
        saveFormRecord.request({
          contentFormId: form.Id!,
          userId: currentUserId,
          type: ContentFormRecordType.UserSignature,
        })
      )
    } else {
      onOpen()
    }
  }

  return (
    <>
      <Button size='small' color='primary' variant='outlined' fullWidth onClick={handleClick}>
        Sign form
      </Button>
      <ManageSignatureDialog isOpen={isOpen} onClose={onClose} />
    </>
  )
}

export default memo(Signature)

